import React from 'react';
import '../assets/styles/PlaceholderComponent.scss';

const PlaceholderComponent = ({ width, height, ...style }) => {
  return <div className='placeholder-loader' style={{ width, height, ...style }}></div>;
};

export default PlaceholderComponent;
